/**
 * Removes the initial sparse value from a sparse array.
 */
export function cleanUpInitialSparseValue<T>(array: T[]) {
  const isSparseArray =
    array.length !== array.filter((_, index) => array.hasOwnProperty(index)).length;

  return isSparseArray && array[0] === undefined ? array.slice(1) : array;
}
